import React from 'react';
import { Link } from 'react-router-dom';
import { IoGlasses } from "react-icons/io5";

function Logo() {
  return (
    <Link to="/en/image-converter" className="flex items-center justify-center py-8">
      <h1 className="flex items-center gap-2 text-4xl font-bold text-blue-600 justify-center">
        <IoGlasses size={50} />
        Llama convert
      </h1>
    </Link>
  );
}

export default Logo;
